module.exports = __webpack_public_path__ + "img/girl.c341684b.png";